module.exports['en-us'] = require('./en-US.js')
module.exports['es-mx'] = require('./es-MX.js')
module.exports['zh-cn'] = require('./zh-CN.js')